import styled from "styled-components";
import { useCartContext } from "../context/cart_context";
import CartItem from "../components/CartItem";
import { Link, NavLink } from "react-router-dom";
import { Button } from "../styles/Button";
import FormatPrice from "../Helpers/FormatPrice";

const Cart = () => {
  const { cart, clearCart, total_price, shippingCharges } = useCartContext();

  if (!cart || cart.length === 0) {
    return (
      <EmptyDiv>
        <h3>No Items in Cart</h3>
      </EmptyDiv>
    );
  }


const total_quantity = cart.reduce((acc, curElem) => acc + curElem.quantity, 0);

const cartSummary = {
  total_quantity,
  subtotal: total_price,
  shipping: shippingCharges,
  Total: total_price + shippingCharges,
};

  return (
    <Wrapper>
      <div >
      <h2>Cart Details </h2>      
      <table className="cart-table">
        <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((curElem) => (
              <CartItem key={curElem.SKU} {...curElem} />
            ))}

            {/* Totals row: Quantity + Subtotal */}
            <tr style={{backgroundColor: "#f4f4f4"}} >
              <td style={{ textAlign: "left", fontWeight: "bold"}}>
                Total - FOB (Mundra Port, India)</td>
              {/* skip Item + Price */}
              <td colSpan="1"></td>
              <td > {cartSummary.total_quantity}</td>
              <td> <FormatPrice price={cartSummary.subtotal} /></td>
              <td></td>
            </tr>

            {/* Shipping Fee row */}
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold"}}>Sea Freight (1 x 20GP)</td>
              <td ></td>
              <td ></td>
              <td><FormatPrice price={cartSummary.shipping} /></td>
              <td></td>
            </tr>

            {/* Order Total row */}
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold"}}>Total (C & F)</td>
              <td ></td>
              <td > {cartSummary.total_quantity}</td>
              <td><strong><FormatPrice price={cartSummary.Total} /></strong></td>
              <td></td>
            </tr>
          </tbody>
        </table>
       </div>

       <div className="cart-button">
          <NavLink to="/products">
            <Button>Continue Shopping</Button>
          </NavLink>
          
          <Button 
          style={{ backgroundColor: "#e74c3c", color: "#fff" }} 
          onClick={clearCart}>
          Clear Cart
          </Button>
         
          <Button 
          style={{ backgroundColor: "#6F9F86", color: "#fff" }}>
                <Link to='/Checkout'>CheckOut</Link> 
          </Button>
          
        </div>
       
    </Wrapper>
  );
};


const EmptyDiv = styled.div`
  display: grid;
  place-items: center;
  height: 50vh;
  

  h3 {
    font-size: 3.2rem;
    text-transform: capitalize;
    font-weight: 300;
    }
  `;


const Wrapper = styled.section`
padding: 5rem 8rem;      


input, select {        
  padding: 5px;          
  font-size: 1.2rem;
  }

.cart-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
  font-size: 1.5rem;
  }

.cart-table th,
.cart-table td {
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: center;
   
  }

.cart-table th {
  background-color: #f4f4f4;
  font-weight: 600;
 
  }

/* ✅ Cart Item Info */
.cart-item-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  }

.cart-item-img {
  width: 80px;
  height: auto;
  border-radius: 4px;
  }

 
.cart-button {
   margin-top: 3rem;
   display: flex;
   justify-content: space-between;
   
   }

.remove_icon {
     color: #e74c3c;
   cursor: pointer;
   }

  .Quantity-toggle {
    margin-top: 1rem;    
    padding: 1rem;
    
  .Quantity-style {
    color: ${({ theme }) => theme.colors.btn};
    padding: 0.5rem ;
    margin-bottom: 1rem;
    }
  }


@media (max-width: ${({ theme }) => theme.media.mobile}) {
    padding: 4rem 0.3rem;
  
 .cart-table,
  .cart-table thead,
  .cart-table tbody,
  .cart-table th,
  .cart-table td,  
  .cart-table tr {
    display: block;
    width: 100%;
    font-size: 12px;
    }

  .cart-table thead {
    display: none;
    }

  .cart-table tr {
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 0.75rem;
    background: #fff;
    }

  .cart-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border: none;
    border-bottom: 1px solid #eee;
    }

  .cart-table td:last-child {
    border-bottom: none;
    }

  .cart-table td::before {
    content: attr(data-label);
    font-weight: 600;
    text-transform: capitalize;
    flex: 1;
    text-align: left;
    color: #555;
    }

  .cart-table td p,
  .cart-table td img,
  .cart-table td span {
    flex: 2;
    text-align: right;
    }

  h2{
  font-size: 25px;
  }

  .cart-item-img {
    width: 50px;
    margin-bottom: 0.5rem;
    }

  svg{
   font-size: 2.5rem;  
   }
  }

`;

 export default Cart;